import { render, staticRenderFns } from "./ProductTierInput.vue?vue&type=template&id=3bc0b920&"
import script from "./ProductTierInput.vue?vue&type=script&lang=ts&"
export * from "./ProductTierInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports